import { AvailabilityStatus, VisibilityStatus } from "../../enums/units.enum";

export interface FloorPlan {
  _id: number;
  name: string;
  unit: string;
  min_price: number;
  property_id: string;
  max_price: number;
  sq_ft: number;
  max_sq_ft: number;
  availablity_date: string;
  min_deposit: number;
  max_deposit: number;
  beds: number;
  baths: number;
  description: string;
  image_title: string;
  image:any;
  waitlist?: boolean;
}

export interface Unit {
  _id: number;
  name: string;
  unit: string;
  min_price: number;
  property_id: string;
  floor_plan_id: string;
  tenant_id: string;
  max_price: number;
  sq_ft: number;
  availability_status: AvailabilityStatus;
  availablity_date: Date | string | null;
  visibility_status: VisibilityStatus;
  visibility_date: Date | string | null;
  min_deposit: number;
  max_deposit: number;
  beds: number;
  baths: number;
  description: string;
  image_title: string;
  image:any;
  images?: any[];
  videos?: any[];
  isSelected?: boolean;
  waitlist?: boolean;
  is_visible?: boolean;
}

export enum Status {
  Pending = "Pending",
  Active = "Active",
  Completed = "Completed",
  CANCELLED = 'Cancelled',
  RESCHEDULED = 'Rescheduled',
}
